import IndividualTable from "../../../IndividualTable";
import { sampleData2 } from "../../sampleData";

const Distance145 = () => {
  let winners = ["27", "207", '64', "49"];
  return <IndividualTable matchType={"8"} gender="F" event="145" subTitle="Kungdo" data={sampleData2} topRankCount="4" winners={winners} />;
};
export default Distance145;
